export default __webpack_public_path__ + "static/media/sigma.786fdc5d.png";